module.exports = __webpack_public_path__ + "static/media/bf30.087cd120.png";